//external
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

//internal
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { EmbedVideo } from 'ngx-embed-video';

//views
// import { VideostreamerComponent } from './views/videostreamer/videostreamer.component';
// import { JsonloaderComponent } from './views/jsonloader/jsonloader.component';
import { VideostreamerListComponent } from './views/videostreamer-list/videostreamer-list.component';
import { VideostreamerDetailsComponent } from './views/videostreamer-details/videostreamer-details.component';

@NgModule({
  declarations: [
    AppComponent,
    // VideostreamerComponent,
    // JsonloaderComponent,
    VideostreamerListComponent,
    VideostreamerDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
	HttpClientModule, 
    EmbedVideo.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }
